module.exports = __webpack_public_path__ + "static/media/linkedin.bd8ee387.svg";